<template>
    <div class="navigation" :class="{'minH2':$route.path=='/Overviews'}">
        <div class="box">
            <el-menu
            :default-active="$store.state.activeIndex"
            class="el-menu-vertical-demo"
            :text-color="cssType==0?'#fff':'#555'"
            :active-text-color="cssType==0?'#fff':'#333'"
            :unique-opened="true"
            @select="select"
            >
                <el-menu-item index="/Overviews" class="left-0" :class="{'isactive':$store.state.activeIndex=='/Overviews'}">
                    <img :src="icon0" class="icon">
                    <span slot="title">概览&nbsp;&nbsp;</span>
                </el-menu-item>
                <el-menu-item index="/Dashboard" :class="{'isactive':$store.state.activeIndex=='/Dashboard'}">
                    <img :src="icon1" class="icon">
                    <span slot="title">运维中心</span>
                </el-menu-item>
                <el-menu-item index="/Devops" :class="{'isactive':$store.state.activeIndex=='/Devops'}" v-if="$store.state.functionList.includes('bigScreenView')" >
                    <img :src="icon2" class="icon">
                    <span slot="title">运维大屏</span>
                </el-menu-item>
                <el-menu-item index="/company" :class="{'isactive':$store.state.activeIndex=='/company'}" v-if="$store.state.functionList.includes('companyView')">
                    <img :src="icon3" class="icon">
                    <span slot="title">企业管理</span>
                </el-menu-item>
                <el-menu-item index="/userList" :class="{'isactive':$store.state.activeIndex=='/userList'}" v-if="$store.state.functionList.includes('userView')">
                    <img :src="icon4" class="icon">
                    <span slot="title">用户管理</span>
                </el-menu-item>
                <el-menu-item index="/roleList" :class="{'isactive':$store.state.activeIndex=='/roleList'}" v-if="$store.state.functionList.includes('roleView')">
                    <img :src="icon5" class="icon">
                    <span slot="title">角色管理</span>
                </el-menu-item>
                <el-menu-item index="/productList" :class="{'isactive':$store.state.activeIndex=='/productList'}" v-if="$store.state.functionList.includes('productView')">
                    <img :src="icon6" class="icon">
                    <span slot="title">产品管理</span>
                </el-menu-item>
                <el-menu-item index="/NoticeRuleList" :class="{'isactive':$store.state.activeIndex=='/NoticeRuleList'}" v-if="$store.state.functionList.includes('noticeRuleView')">
                    <img :src="icon7" class="icon">
                    <span slot="title">通知规则</span>
                </el-menu-item>
                <el-menu-item index="/dataset" :class="{'isactive':$store.state.activeIndex=='/dataset'}" class="left-5" v-if="$store.state.functionList.includes('datasetView')">
                    <img :src="icon8" class="icon">
                    <span slot="title">数据集</span>
                </el-menu-item>
                <!--  -->
                <el-menu-item index="/Workorder" class="left-0" :class="{'isactive':$store.state.activeIndex=='/Workorder'}" v-if="$store.state.functionList.includes('workorderView')">
                    <img :src="icon11" class="icon">
                    <span slot="title">工单&nbsp;&nbsp;</span>
                </el-menu-item>
                <el-menu-item index="/FormsList" class="left-0" :class="{'isactive':$store.state.activeIndex=='/FormsList'}" v-if="$store.state.functionList.includes('reportView')">
                    <img :src="icon11" class="icon">
                    <span slot="title">报表&nbsp;&nbsp;</span>
                </el-menu-item>
                <!-- &&env=='local' -->
                <!--
                <el-menu-item index="/backups" :class="{'isactive':$store.state.activeIndex=='/backups'}" v-if="$store.state.functionList.includes('systemConfigBackup')"> 
                    <img :src="icon12" class="icon" style="width: 16px;margin-right: 1px;">
                    <span slot="title">备份恢复</span>
                </el-menu-item>
                -->
                <el-submenu index="8" v-if="$store.state.functionList.includes('aiView')">
                    <template slot="title">
                        <img :src="icon13" class="icon">
                        <span slot="title">智能应用</span>
                    </template>
                    <el-menu-item-group class="menu">
                        <el-menu-item index="/IntelligentPrediction" :class="{'isactive':$store.state.activeIndex=='/IntelligentPrediction'}">单参数模型</el-menu-item>
                        <el-menu-item index="/MultiModel" :class="{'isactive':$store.state.activeIndex=='/MultiModel'}">多参数模型</el-menu-item>
                    </el-menu-item-group>
                </el-submenu>
                <el-submenu index="9" v-if="$store.state.functionList.includes('systemConfigView')">
                    <template slot="title">
                        <img :src="icon9" class="icon">
                        <span>平台设置</span>
                    </template>
                    <el-menu-item-group class="menu">
                        <el-menu-item index="/parameter" :class="{'isactive':$store.state.activeIndex=='/parameter'}">平台参数</el-menu-item>
                        <el-menu-item index="/category" :class="{'isactive':$store.state.activeIndex=='/category'}">类别设置</el-menu-item>
                        <el-menu-item index="/material" :class="{'isactive':$store.state.activeIndex=='/material'}">设备素材</el-menu-item>
                        <el-menu-item index="/deviceSim" :class="{'isactive':$store.state.activeIndex=='/deviceSim'}">sim卡管理</el-menu-item>
                        <el-menu-item index="/systemNotice" :class="{'isactive':$store.state.activeIndex=='/systemNotice'}">公告管理</el-menu-item>
                    </el-menu-item-group>
                </el-submenu>
                <el-submenu index="10" v-if="$store.state.functionList.includes('logPlatform')||$store.state.functionList.includes('logSystem')">
                    <template slot="title">
                    <img :src="icon10" class="icon">
                    <span>系统日志</span>
                    </template>
                    <el-menu-item-group class="menu">
                        <el-menu-item index="/productLog" v-if="$store.state.functionList.includes('logPlatform')" :class="{'isactive':$store.state.activeIndex=='/productLog'}">平台日志</el-menu-item>
                        <el-menu-item index="/userLog" v-if="$store.state.functionList.includes('logSystem')" :class="{'isactive':$store.state.activeIndex=='/userLog'}">用户日志</el-menu-item>
                    </el-menu-item-group>
                </el-submenu>
            </el-menu>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            icon0:require("@/assets/image/left/overview"+this.cssType+".png"),    //概览
            icon1:require("@/assets/image/left/core"+this.cssType+".png"),         //运维中心
            icon2:require("@/assets/image/left/bigScreen"+this.cssType+".png"),    //运维大屏
            icon3:require("@/assets/image/left/enterprise"+this.cssType+".png"),   //企业管理
            icon4:require("@/assets/image/left/userAdmin"+this.cssType+".png"),    //用户管理
            icon5:require("@/assets/image/left/roleAdmin"+this.cssType+".png"),    //角色管理
            icon6:require("@/assets/image/left/product"+this.cssType+".png"),      //产品管理
            icon7:require("@/assets/image/left/notice"+this.cssType+".png"),       //通知规则
            icon8:require("@/assets/image/left/dataSet"+this.cssType+".png"),      //数据集
            icon9:require("@/assets/image/left/setUp"+this.cssType+".png"),        //平台设置
            icon10:require("@/assets/image/left/journal"+this.cssType+".png"),     //系统日志
            icon11:require("@/assets/image/left/ReportForms"+this.cssType+".png"), //数据集
            icon12:require("@/assets/image/left/backups"+this.cssType+".png"),     //备份恢复
            icon13:require("@/assets/image/left/ai.png"),     //备份恢复
            // index:'/Dashboard'
        }
    },
    // computed: {
    //     test(){
    //         return this.$store.state.activeIndex
    //     }
    // },
    methods: {
        select(key){
            if(this.$route.path == '/parameter'&&this.$store.state.isEdit&&key!='/parameter'){
                this.$store.state.activeIndex = '/parameter'
                this.$confirm('当前页面编辑内容尚未保存，是否离开?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$store.state.isEdit = false
                    this.$router.push({path:key});
                    this.$store.state.activeIndex = key
                })
            }else if(this.$route.path == '/NoticeRuleList'&&this.$store.state.isEdit&&key!='/NoticeRuleList'){
                this.$confirm('当前页面编辑内容尚未保存，是否离开?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$store.state.isEdit = false
                    this.$router.push({path:key});
                    this.$store.state.activeIndex = key
                }).catch(()=>{
                    this.$store.state.activeIndex = '/NoticeRuleList'
                })
            }else if((this.$route.path == '/DevopsAdd'||this.$route.path == '/DevopsEdit')&&this.$store.state.isEdit){
                this.$confirm('当前页面编辑内容尚未保存，是否离开?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$store.state.isEdit = false
                    this.$router.push({path:key});
                    this.$store.state.activeIndex = key
                }).catch(()=>{
                    this.$store.state.activeIndex = '/Devops'
                })
            }else{
                this.$router.push({path:key})
                this.$store.state.isEdit = false
            }
            // this.$router.push({path:key})
        }
    },
    // watch: {
    //     index(val){
    //         if(val!=this.$store.state.activeIndex){
    //             this.$store.state.activeIndex = val
    //             console.log(val)
    //         }
    //     },
    //     test(val){
    //         if(val!=this.index){
    //             this.index = val
    //             console.log(this.index)
    //         }
    //     }
    // },
}
</script>
<style scoped>
    .minH2{
      min-height: 868px !important;
    }
    .el-menu{
        background: transparent !important;
    }
    .navigation{
        width:250px;
        position: absolute;
        top: 75px;
        left: 0;
        bottom: 0;
        background-color: #2f3a4e;
        padding-top: 24px;
        min-height: 773px;
        z-index: 0;
        overflow: auto;
    }
    .lists{
        width: 100%;
        line-height: 52px;
        position: relative;
    }
    .lists:hover{
        background-color: #575f70;
    }
    .lists-txt{
        color: #fff;
        font-size: 16px;
        font-weight: 400;
    }
    .icon{
        width: 20px;
        position: relative;
        /* top: 5px; */
        right: 5px;
    }
    .lab-box{
        width: 110px;
        margin: 0 auto;
        text-align: left;
    }
    .active:hover{
        background-color: #575f70;
    }
    .active2{
        background-color: #575f70;
    }
    .left-5{
        padding-left: 5px !important;
    }
    .left-0{
        padding-left: 0px !important;

    }
    .el-menu-item.isactive{
        background-color: #575f70;
    }
    .el-menu-item.isactive:after{
        content: "";
        display: block;
        position: absolute;
        top:0;
        width: 8px;
        left: 0;
        height: 100%;
        background-color: #5087e4;
    }
    .el-submenu__title:hover{
        background-color: #575f70;
    }
    .el-menu-item:hover{
        background-color: #575f70 ;
    }
    .el-menu-item-group.menu{
        background: #2f3a4e;
    }
    .el-menu{
        border: 0 !important;
    }
</style>
<style>
    .el-submenu .el-submenu__title:hover{
        background-color: #575f70;
    }
</style>



// WEBPACK FOOTER //
// src/components/PublicAssembly/leftNavigation.vue